```vue
<template>
  <div class="original-language-viewer">
    <div class="olv-header" @click="toggle">
      <icon size="0.9" :type="isOpen ? 'angle-right' : 'angle-down'" class="d-inline-block mr-1" />
      <span class="olv-title d-inline-block">{{ $t('vform.originalText')}}</span>
    </div>

    <transition v-if="!isOpen" name="olv-collapse">
      <copy-to-clipboard-text
          v-if="originalText"
          copy-icon-position="bottom-right"
          :key="forceReRenderKey"
          :value="originalText" />
      <div v-else>–</div>
    </transition>
  </div>
</template>

<script>
import CopyToClipboardText from "@/components/CopyToClipboardText.vue";
import Icon from "@/components/Icon.vue";
export default {
  name: 'OriginalLanguageViewer',
  components: { CopyToClipboardText, Icon },
  props: {
    originalText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      forceReRenderKey: 0,
      isOpen: true,
      copied: false
    };
  },
  watch: {
    originalText() {
      // reset state when original text changes
      this.isOpen = true;
      this.copied = false;
      this.forceReRenderKey++;
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  }
};
</script>

<style scoped lang="scss">
.original-language-viewer {
  background-color: $highlight;
  border-radius: 3px;
  padding: 2px 8px;
}

.olv-header {
  cursor: pointer;
}

.olv-title {
  font-weight: 400;
  font-size: 0.8rem;
}

.olv-body {
  margin-top: 6px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* simple collapse transition */
.olv-collapse-enter-active,
.olv-collapse-leave-active {
  transition: max-height 0.2s ease, opacity 0.2s ease;
}
.olv-collapse-enter-from,
.olv-collapse-leave-to {
  max-height: 0;
  opacity: 0;
}
.olv-collapse-enter-to,
.olv-collapse-leave-from {
  max-height: 500px;
  opacity: 1;
}
</style>